module.exports = __webpack_public_path__ + "static/images/appointments.e4c57c6a2bf76a1682174c0591890fb3.svg";